import React, { useEffect, useState } from "react";
import Shell from "@/components/Shell";
import api, { formatINR } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const fmt = (v) => {
  if (v === null || v === undefined || v === "") return <span className="text-zinc-400">—</span>;
  if (typeof v === "number") return formatINR(v);
  return String(v);
};

export default function Audit() {
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/audit").then((r) => setItems(r.data)); }, []);

  return (
    <Shell title="Audit Log" subtitle="Every change made to invoices, with who and when.">
      <Card className="border-zinc-200 shadow-none rounded-md overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-zinc-50">
              <TableHead className="font-bold text-zinc-950">When</TableHead>
              <TableHead className="font-bold text-zinc-950">Actor</TableHead>
              <TableHead className="font-bold text-zinc-950">Invoice</TableHead>
              <TableHead className="font-bold text-zinc-950">Field</TableHead>
              <TableHead className="font-bold text-zinc-950">Old</TableHead>
              <TableHead className="font-bold text-zinc-950">New</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow><TableCell colSpan={6} className="text-center py-10 text-zinc-500">No changes logged yet.</TableCell></TableRow>
            )}
            {items.map((a) => (
              <TableRow key={a._id} data-testid={`audit-row-${a._id}`}>
                <TableCell className="text-zinc-600 text-xs tabular-nums">{new Date(a.timestamp).toLocaleString()}</TableCell>
                <TableCell>
                  <div className="font-semibold">{a.actor_name}</div>
                  <div className="text-xs text-zinc-500">{a.actor_email}</div>
                </TableCell>
                <TableCell className="font-semibold">#{a.invoice_no}</TableCell>
                <TableCell>{a.field_label}</TableCell>
                <TableCell className="text-zinc-600">{fmt(a.old_value)}</TableCell>
                <TableCell className="font-semibold">{fmt(a.new_value)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Shell>
  );
}
